import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Row, Col, Spin } from "antd";
import { Alert, Divider, Typography } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { withRouter } from "react-router-dom";
import { MailOutlined, LockOutlined, LoadingOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  cleanUsuario,
  getUsuarioLogin,
  getUsuarioLogout,
} from "../../../redux/usuario/usuarioDucks";
import { DATE_FORMAT_EXP, valueLowerCase } from "../../../utils";
import { CAP_KEY, linksRouter } from "../../../config/RouterLink";
import { Link } from "react-router-dom";
import { CORREO } from "../../../utils";
import moment from "moment";

const { Item } = Form;
const { Text } = Typography;

function FormLogin(props) {
  const { form, openOrCloseModal } = props;
  const dispatch = useDispatch();
  const [captcha, setCaptcha] = useState("");
  const [error, setError] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [cargandoInfo, setCargandoInfo] = useState(false);
  const isMounted = useRef(true);

  const { autenticado, messageError, indicadorError, estatusAcceso } =
    useSelector((store) => store.usuarioLogin);
  const { isPruebas } = useSelector((state) => state.catalogos);
  const { get_registro, get_FechaPostulacion } = useSelector(
    (state) => state.sistemas
  );
  //console.log(location);
  useEffect(() => {
    return () => {
      //Desmontar el componente
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      if (estatusAcceso === "0") {
        props.history.push(linksRouter.update);
      } else {
        if (autenticado) {
          // props.history.push(linksRouter.home);
          props.history.push({
            pathname: linksRouter.home,
            state: { register: true },
          });
          if (estatusAcceso === "2") {
            props.history.push(linksRouter.cuentaDesactivada);
            dispatch(getUsuarioLogout());
          }
        } else {
          dispatch(cleanUsuario());
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autenticado]);

  const onFinish = (values) => {
    if (!captcha && !isPruebas) {
      setError(true);
      setMessageAlert(
        "El código de seguridad es obligatorio, favor de verificarlo."
      );
    } else {
      setError(false);
      setCargandoInfo(true);
      dispatch(getUsuarioLogin(values.usuario, values.password)).then(() => {
        setCargandoInfo(false);
      });
    }
  };

  const handleCaptcha = (e) => {
    setError(false);
    if (e != null) {
      setCaptcha(e);
    }
  };

  const validaFecha = () => {
    if (get_FechaPostulacion !== null && get_FechaPostulacion !== undefined) {
      const { fechaInicio, fechaFin } = get_FechaPostulacion;
      const hoy = new Date(moment().format(DATE_FORMAT_EXP));
      const startDate = new Date(moment(fechaInicio).format(DATE_FORMAT_EXP));
      const endDate = new Date(moment(fechaFin).format(DATE_FORMAT_EXP));
      //Si la fecha actual es menor a la fecha inicio se bloquea el botón
      if (hoy < startDate) return true;
      //Si la fecha actual es igual o mayor a la fecha inicio y no existe fecha fin se habilita el botón
      if (hoy >= startDate && isNaN(endDate.getTime())) {
        return false;
      }
      //Si la fecha actual se encuentra en el rango de las fechas inicio y fin se habilita el botón
      //Si ya pasaron las fechas y el estatus se encuentra en 1, solo se bloquea el botón
      return hoy >= startDate && hoy <= endDate ? false : true;
    }
  };

  return (
    <div className="">
      <Spin
        spinning={cargandoInfo}
        size="large"
        indicator={
          <LoadingOutlined style={{ fontSize: 50, color: "#9254de" }} spin />
        }
      >
        <div className="ibox-title">
          <Row>
            <Col span={24}>
              <h1
                style={{
                  paddingTop: "25px",
                  paddingBottom: "30px",
                }}
                className="login-title"
              >
                Concursos Públicos del SPEN
              </h1>
            </Col>
          </Row>
        </div>

        <div className="login-container">
          <Form
            name="basic"
            className="login-form"
            onFinish={onFinish}
            form={form}
            // onFinishFailed={onFinishFailed}
          >
            <Item
              name="usuario"
              rules={CORREO}
              getValueFromEvent={valueLowerCase}
            >
              <Input
                prefix={<MailOutlined style={{ color: "#9254de" }} />}
                placeholder="Correo electrónico"
                autoCapitalize="none"
                type="email"
                size="large"
                style={{ width: "300px" }}
                maxLength={100}
              />
            </Item>

            <Item
              name="password"
              rules={[
                { required: true, message: "Campo contraseña requerido." },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: "#9254de" }} />}
                type="password"
                size="large"
                placeholder="Contraseña"
                style={{ width: "300px" }}
                maxLength={51}
              />
            </Item>

            <div style={{ marginBottom: 12, width: "75%" }}>
              {error && (
                <Alert message={messageAlert} type="error" showIcon closable />
              )}

              {indicadorError && (
                <Alert message={messageError} type="error" showIcon closable />
              )}
            </div>

            <Item>
              <ReCAPTCHA sitekey={CAP_KEY} onChange={handleCaptcha} />
              <Divider />

              <div style={{ paddingTop: "1%", textAlign: "center" }}>
                <Button
                  style={{
                    align: "center",
                    width: "77%",
                    borderBottom: " 2px solid #9254de !important",
                    backgroundColor: "#9254de",
                    borderRadius: "11px",
                    borderColor: "#9254de",
                  }}
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  size="large"
                >
                  Iniciar sesión
                </Button>
              </div>
              <div
                style={{
                  paddingTop: "3%",
                  textAlign: "left",
                  paddingLeft: "13%",
                  fontSize: "16px",
                }}
              >
                <Link
                  onChange={openOrCloseModal}
                  to={linksRouter.correo}
                  style={{ textDecoration: "underline", color: "#9254de" }}
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
              {get_registro !== null &&
              get_registro !== undefined &&
              get_registro.valorConfiguracion === "1" ? (
                <div hidden={validaFecha()}>
                  <div
                    style={{
                      paddingTop: "5%",
                      textAlign: "left",
                      paddingLeft: "13%",
                      fontSize: "16px",
                    }}
                  >
                    <Text strong>¿Aún no tienes cuenta?</Text>
                  </div>
                  <div
                    style={{
                      textAlign: "left",
                      paddingLeft: "13%",
                      fontSize: "16px",
                    }}
                  >
                    <Link
                      to={linksRouter.registro}
                      style={{ textDecoration: "underline", color: "#9254de" }}
                    >
                      Regístrate
                    </Link>
                    <Text> para iniciar con tu solicitud</Text>
                  </div>
                </div>
              ) : (
                <div style={{ marginTop: 25 }}></div>
              )}
            </Item>
          </Form>
        </div>
      </Spin>
    </div>
  );
}

export default withRouter(FormLogin);
